import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_recurring_generic_doc_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  recurring_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  recurring_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  link_guid: fromDatatype.GuidDataFieldInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_recurring_generic_doc_event_RowClass
  implements bl_fi_recurring_generic_doc_event_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  recurring_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  recurring_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  link_guid: fromDatatype.GuidDataFieldInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
